// extracted by mini-css-extract-plugin
export default {"right-section":"RightSection_right-section__adxYu","header":"RightSection_header__0O+v7","social-media":"RightSection_social-media__Hycry"};